module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card",
    class: {
      'card_carousel': _vm.carousel
    }
  }, [_c('component', _vm._b({
    staticClass: "card__info"
  }, 'component', _vm.componentAttrs, false), [_c('Picture', {
    attrs: {
      "src": _vm.image,
      "alt": _vm.title,
      "finished": _vm.finished
    }
  }), _c('h3', {
    staticClass: "card__title"
  }, [_vm._v(_vm._s(_vm.title))])], 1), _c('div', {
    staticClass: "card__footer"
  }, [(!_vm.isFavorite && !_vm.external) ? _c('div', {
    staticClass: "card__favorite",
    class: {
      'card__favorite_active': _vm.favorite
    },
    on: {
      "click": _vm.toggle
    }
  }) : _vm._e(), _c('component', _vm._b({
    staticClass: "card__more"
  }, 'component', _vm.componentAttrs, false), [_vm._v("Подробнее")]), (_vm.isFavorite && !_vm.external) ? _c('div', {
    staticClass: "card__delete",
    on: {
      "click": _vm.toggle
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a8e141c","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/blocks/cards/simple/Simple.vue
// module id = c537dcebe7901951362c
// module chunks = 89